export default __webpack_public_path__ + "static/media/emoji-agenda.7fb82fcc.svg";